import { nameCodePair } from '../../models/keyValuePair';

export const responseStatus = {
  SUCCESS: 200,
  NOCONTENT: 204,
  BADREQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  REQUESTTIMEOUT: 408,
  RequestTookMoreThanExpected: 429,
  INTERNALSERVERERROR: 500,
  GatewayTimeOut: 504,
};

export const ImmeditateTime: Array<nameCodePair> = [
  { name: '15', code: 1 },
  { name: '30', code: 2 },
  { name: '60', code: 3 },
];
